import React, { useEffect, useRef, useState } from "react";

const VIDEO_SRC =
  "https://customer-assets.emergentagent.com/job_yazid-innovator/artifacts/mv3h07kt_WhatsApp%20Video%202026-05-28%20at%2011.05.10%20PM.mp4";

const STATS = [
  { value: 3, suffix: "", label: "Registered Patents" },
  { value: 5, suffix: "+", label: "Prestigious Prizes" },
  { value: 8, suffix: "", label: "AI Platforms Built" },
  { value: 100, suffix: "+", label: "Students Mentored" },
];

const Counter = ({ value, suffix = "", duration = 1800 }) => {
  const [n, setN] = useState(0);
  const ref = useRef(null);
  const started = useRef(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const io = new IntersectionObserver(
      ([e]) => {
        if (e.isIntersecting && !started.current) {
          started.current = true;
          const start = performance.now();
          const step = (t) => {
            const p = Math.min((t - start) / duration, 1);
            const eased = 1 - Math.pow(1 - p, 3);
            setN(Math.round(value * eased));
            if (p < 1) requestAnimationFrame(step);
          };
          requestAnimationFrame(step);
        }
      },
      { threshold: 0.4 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [value, duration]);
  return (
    <span ref={ref}>
      {n}
      {suffix}
    </span>
  );
};

const VideoStats = () => (
  <section
    id="impact"
    data-testid="section-impact"
    className="relative overflow-hidden text-alabaster"
  >
    {/* Video background */}
    <video
      data-testid="impact-video"
      className="absolute inset-0 w-full h-full object-cover"
      style={{ objectPosition: "center 25%" }}
      src={VIDEO_SRC}
      autoPlay
      loop
      muted
      playsInline
      preload="metadata"
      aria-hidden="true"
    />
    {/* Dark overlay — light tint matching YOUthRIVING */}
    <div className="absolute inset-0 bg-ink/40" aria-hidden />

    <div className="relative max-w-7xl mx-auto px-6 sm:px-10 py-24 sm:py-32">
      <div className="text-center max-w-4xl mx-auto reveal">
        <h2
          data-testid="impact-heading"
          className="font-display text-4xl sm:text-5xl lg:text-6xl font-bold leading-[1.1] tracking-tight"
        >
          Driving Innovation with{" "}
          <span className="text-terracotta">Emerging Technologies</span>
        </h2>
        <p className="mt-5 text-base sm:text-lg text-alabaster/80 leading-relaxed">
          Fourteen years at the crossroads of AI, education and innovation — building
          platforms, registering patents, mentoring world-stage students.
        </p>
      </div>

      <div className="mt-16 sm:mt-20 grid grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-6">
        {STATS.map((s, i) => (
          <div
            key={s.label}
            data-testid={`impact-stat-${i}`}
            className="reveal text-center"
            style={{ transitionDelay: `${i * 80}ms` }}
          >
            <div className="font-display text-6xl sm:text-7xl lg:text-[88px] font-bold tracking-tight leading-none">
              <Counter value={s.value} suffix={s.suffix} />
            </div>
            <div className="mt-4 text-sm sm:text-base text-alabaster/85 font-display font-medium">
              {s.label}
            </div>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default VideoStats;
